/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/generate/GeneratePassword.ts
 * @create:      2025-06-28 09:39:44.548
 * @modify:      2025-07-11 21:19:12.893
 * @version:     6.0.0
 * @times:       8
 * @lines:       70
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_Empty, Strings_LowercaseLetters, Strings_Numbers, Strings_PasswordSpecialCharacters, Strings_UppercaseLetters } from "../const/Strings";
import { GenerateRandomString } from "./GenerateRandomString";

/**
 * Generates a random password string based on the specified criteria.
 *
 * @param length - The desired length of the generated password.
 * @param numbers - Whether to include numeric characters (default: true).
 * @param lowercaseLetters - Whether to include lowercase letters (default: true).
 * @param uppercaseLetters - Whether to include uppercase letters (default: true).
 * @param specialCharacters - Whether to include special characters (default: true).
 * @returns A randomly generated password string.
 * @throws {Error} If no character types are selected.
 * 
 * @since 1.0.5
 * @version 2021-12-11
 */
export function GeneratePassword(length: number, numbers = true, lowercaseLetters = true, uppercaseLetters = true, specialCharacters = true) {
    let chars = Strings_Empty;
    if (numbers) {
        chars += Strings_Numbers;
    }
    if (lowercaseLetters) {
        chars += Strings_LowercaseLetters;
    }
    if (uppercaseLetters) {
        chars += Strings_UppercaseLetters;
    }
    if (specialCharacters) {
        chars += Strings_PasswordSpecialCharacters;
    }
    if (chars.length > 0) {
        return GenerateRandomString(length, chars);
    } else {
        throw new Error("Invalid parameters");
    }
}
